import { IconsProps } from '@/types/shared'
import React from 'react'

const MoveIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.6875 9.375L8.16406 10.8984L9.47656 12.2109L13.25 8.4375L9.47656 4.66406L8.16406 5.97656L9.6875 7.5H5.75V9.375H9.6875ZM2 15C1.48438 15 1.04297 14.8164 0.675781 14.4492C0.308594 14.082 0.125 13.6406 0.125 13.125V1.875C0.125 1.35938 0.308594 0.917969 0.675781 0.550781C1.04297 0.183594 1.48438 0 2 0H7.625L9.5 1.875H17C17.5156 1.875 17.957 2.05859 18.3242 2.42578C18.6914 2.79297 18.875 3.23438 18.875 3.75V13.125C18.875 13.6406 18.6914 14.082 18.3242 14.4492C17.957 14.8164 17.5156 15 17 15H2ZM2 13.125H17V3.75H8.72656L6.85156 1.875H2V13.125Z"
                    fill="#626262"
                />
            </svg>
        </div>
    )
}

export default MoveIcons
